import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = createQueryKeySet('users');

export function useUserListQuery() {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.usersList();
      return data;
    },
    queryKey: keys.list(),
  });
}

export function useUserQuery(userId: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.usersRetrieve(userId);
      return data;
    },
    queryKey: keys.detail(userId),
  });
}
